export default {
  'referral-title': '%{firstname}, un bon plan, ça se partage !',
  'referral-title-default': 'Un bon plan, ça se partage !',
  'your-referral-code-is': 'Votre code parrain est :',
  'referral-description':
    'Vous avez aimé nos délicieux produits frais ? Pourquoi ne pas en parler autour de vous ?<br/>Vous aussi, devenez ambassadeur du goût, parrainez vos proches et gagnez des récompenses !',
};
